export function formatPrice (cents) {
  const dollars = cents / 100
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: Shopify.currency.active,
  })
    .format(dollars)
    .replace(/\.00$/, '')
}

export function getTimestamp () {
  return new Date().getTime()
}

export function fetchConfig () {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  }
}

export async function handleFetchResponse (response) {
  if (!response.ok) {
    const error = await response.json()
    throw new Error(error?.description || error.message || 'An error occurred')
  }

  return response.json()
}

export async function addToCart (formData) {
  const config = fetchConfig('javascript')
  config.headers['X-Requested-With'] = 'XMLHttpRequest'
  delete config.headers['Content-Type']
  config.body = formData
  const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config)
  return handleFetchResponse(response)
}

export async function updateCart ({ data }) {
  const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
    ...fetchConfig(),
    body: JSON.stringify({ ...data }),
  })
  return handleFetchResponse(response)
}

export async function changeCart ({ id, quantity, planId, sections }) {
  const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
    ...fetchConfig(),
    body: JSON.stringify({ id, quantity, selling_plan: planId, sections }),
  })
  return handleFetchResponse(response)
}